// extracted by mini-css-extract-plugin
module.exports = {"card":"card-module--card--1_HJn","media":"card-module--media--19AcV","cardTitle":"card-module--card-title--2oc9g","cardText":"card-module--card-text--IOBR_"};